import { useEffect, useRef } from 'react'

import { type PurchasePayload, pushPurchase } from '@/lib/gtm'

const STORAGE_PREFIX = 'gtm_purchase_'

/**
 * Pousse l'événement `purchase` GTM une seule fois par transaction.
 *
 * Double garde :
 * - `ref` : neutralise le double-rendu du React StrictMode.
 * - `sessionStorage` (clé = transactionId) : évite un nouveau push si l'utilisateur
 *   rafraîchit la page de confirmation (sinon Google Ads compte 2× la vente).
 *
 * Passer `null` tant que les données de la réservation ne sont pas chargées.
 */
export function useTrackPurchaseOnce(payload: null | PurchasePayload): void {
  const firedRef = useRef(false)

  useEffect(() => {
    if (!payload || firedRef.current) {
      return
    }

    const storageKey = `${STORAGE_PREFIX}${payload.transactionId}`
    try {
      if (sessionStorage.getItem(storageKey)) {
        return
      }
      sessionStorage.setItem(storageKey, '1')
    } catch {
      // sessionStorage indisponible (mode privé, etc.) — on retombe sur la ref seule.
    }

    firedRef.current = true
    pushPurchase(payload)
  }, [payload])
}
